(function() {
	'use strict';

	angular
		.module('app.leanProjects')
		.service('xMatrixService', xMatrixService);

	xMatrixService.$inject = ['$http', 'URLS', '$translate', 'leanFilterService'];

	function xMatrixService($http, URLS, $translate, leanFilterService) {
		var filters = {};
		filters.freshFilters = false;
		var service = {
			getUndefinedValueStream: getUndefinedValueStream,
			getProjects: getProjects,
			getMetrics: getMetrics,
			getGoals: getGoals,
			getFactoryMetricDateRange: getFactoryMetricDateRange
		};
		return service;

		function getUndefinedValueStream() {
			return $http.get(URLS.host + URLS.prefix + leanFilterService.getFactoryList() + '/LeanProjects/XMatrix/UndefinedValueStream')
				.then(getUndefinedValueStreamSuccess, getUndefinedValueStreamError);

			function getUndefinedValueStreamSuccess(response) {
				return response.data;
			}

			function getUndefinedValueStreamError() {
				// TODO: Show some type of error message
			}
		}

		function getProjects() {
			var url = URLS.host + URLS.prefix + leanFilterService.getFactoryList() + '/LeanProjects/XMatrix/Projects';
			url = addQueryParam(url,
				globalConfig.factory.id, leanFilterService.getQueryParamsObject(true), false);
			return $http.get(url).then(getProjectsSuccess, getProjectsError);

			function getProjectsSuccess(response) {
				return response.data;
			}

			function getProjectsError() {
				// TODO: Show some type of error message
			}
		}

		function getMetrics() {
			var url = URLS.host + URLS.prefix + leanFilterService.getFactoryList() + '/LeanProjects/XMatrix/ProjectMetrics';
			url = addQueryParam(url,
				globalConfig.factory.id, leanFilterService.getQueryParamsObject(true), false);
			return $http.get(url).then(getMetricsSuccess, getMetricsError);

			function getMetricsSuccess(response) {
				return response.data;
			}

			function getMetricsError() {
				// TODO: Show some type of error message
			}
		}

		function getGoals() {
			var url = URLS.host + URLS.prefix + leanFilterService.getFactoryList()+ '/LeanProjects/XMatrix/ProjectGoals';
			url = addQueryParam(url,
				globalConfig.factory.id, leanFilterService.getQueryParamsObject(true), false);
			return $http.get(url).then(getGoalsSuccess, getGoalsError);

			function getGoalsSuccess(response) {
				return response.data;
			}

			function getGoalsError() {
				// TODO: Show some type of error message
			}
		}

		function getFactoryMetricDateRange() {
			return $http.get(URLS.host + URLS.prefix + leanFilterService.getFactoryList() + '/FactoryControlVariables/FactoryMetricDateRange')
				.then(getFactoryMetricDateRangeComplete)
				.catch(getFactoryMetricDateRangeFailed);

			function getFactoryMetricDateRangeComplete(response) {
				return response.data;
			}

			function getFactoryMetricDateRangeFailed(error) {
				return undefined;
			}
		}
	}

})();
